import { LifeTransactionType } from '../enums';

export const LifeConstants = {
  // Life Transaction Amounts
  rescueShiftHealAmount: 1,
  unexcusedAbsencePenaltyAmount: -2,
  attendanceStreakAmount: 1,
  canceledLateShiftAmount: -1,
  approvedExcuseAmount: 1,
  employerCancellationAmount: 1,

  // Other
  attendancesNeededForStreak: 20,
  banThreshold: -2,
  maxLives: 3,
  initialLives: 2,
  onlyRescueShiftThreshold: 0,
  gracePeriodInMinutes: 15,
  releaseDate: '2025-06-11',
  rescueShiftMaxHoursBeforeShift: 12,
  lateCancelMaxHoursBeforeShift: 48,
  employerCancellationMaxHoursBeforeShift: 48,
};

export const LifeTransactionAmounts: Record<LifeTransactionType, number> = {
  [LifeTransactionType.INITIAL]: LifeConstants.initialLives,
  [LifeTransactionType.UNEXCUSED_ABSENCE]:
    LifeConstants.unexcusedAbsencePenaltyAmount,
  [LifeTransactionType.MANUAL]: 0,
  [LifeTransactionType.RESCUE_SHIFT]: LifeConstants.rescueShiftHealAmount,
  [LifeTransactionType.ATTENDANCE_STREAK]: LifeConstants.attendanceStreakAmount,
  [LifeTransactionType.CANCELED_LATE_SHIFT]:
    LifeConstants.canceledLateShiftAmount,
  [LifeTransactionType.APPROVED_EXCUSE]: LifeConstants.approvedExcuseAmount,
  [LifeTransactionType.EMPLOYER_CANCELLATION]:
    LifeConstants.employerCancellationAmount,
};
